import "./App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Helmet } from "react-helmet";
import Login from "./pages/Login";
import DashBoard from "./pages/DashBoard/DashBoard";
import PrivateRoute from "./routes/PrivateRoute";
import PublicRoute from "./routes/PublicRoute";
import Main from "./components/Main";
import Tournament from "./pages/tournament/Tournament";
import TournamentRanking from "./pages/TournamentRanking/TournamentRanking";
import Cafe from "./pages/cafe/cafe";
import Notice from "./pages/notice/notice";
import Faq from "./pages/faq/faq";
import User from "./pages/user/user";
import AppUpdate from "./pages/appUpdate/appUpdate";
import TournamentAdmin from "./pages/tournamentAdmin";
import ReferralSales from "./pages/referralSales/referralSales";
import GameSetting from "./pages/gameSetting/gameSetting";
import Advertisement from "./pages/adbertisement/advertisement";
import Youtube from "./pages/youtube/Youtube";
import YoutubeChannel from "./pages/youtubeChannel/youtubeChannel";
import Coupon from "./pages/coupon";
import GameCoupon from "./pages/gameCoupon";
import GameCouponList from "./pages/gameCouponList";
import AttendanceTable from "./pages/attendanceTable";
import AttendanceHistory from "./pages/attendanceUser";
import AttendanceReward from "./pages/attendanceReward";
import GameInspectionSchedule from "./pages/GameInspectionSchedule";
import UserGamePoint from "./pages/userGamePoint";
import Club from "./pages/club/Club";
import ClubCreate from "./pages/club-create";
import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { loadingState } from "./recoil/loading.atom";
import { setLoadingStateSetter } from "./utils/apiUtils";
import ManualGpPayment from "./pages/manualGpPayment";
import ManualGpPaymentLog from "./pages/manualGpPaymentLog";
import GameBan from "./pages/game-ban/game-ban";
import TournamentAdVideo from "./pages/tournament-ad-video/tournament-ad-video";
import Socail from "./pages/social/Social";
import RunnerCompetition from "./pages/runnerCompetition/runnerCompetition";
import ImagePopup from "./pages/image-popup";
import Gallery from "./pages/gallery/gallery";
function App() {
  const setLoading = useSetRecoilState(loadingState);

  // 리코일 못 쓰니까 함수 전달용
  useEffect(() => {
    setLoadingStateSetter(setLoading);
  }, [setLoading]);
  return (
    <BrowserRouter>
      <Helmet>
        <title>
          {process.env.ENV === "prod"
            ? "[LIVE]러너러너 운영툴"
            : "[TEST]러너러너 운영툴"}
        </title>
      </Helmet>

      <Routes>
        <Route path="/login" element={<PublicRoute />}>
          <Route path="/login" element={<Login />} />
        </Route>

        <Route path="/" element={<PrivateRoute />}>
          <Route path="/" element={<Main />}>
            <Route path="/" element={<DashBoard />} />
            <Route
              path="/tournament-ad-video"
              element={<TournamentAdVideo />}
            />
            <Route path="/tournament" element={<Tournament />} />
            <Route path="/club" element={<Club />} />
            <Route path="/social" element={<Socail />} />
            <Route path="/tournamentRanking" element={<TournamentRanking />} />
            <Route path="/runnerCompetition" element={<RunnerCompetition />} />
            <Route path="/cafe" element={<Cafe />} />
            <Route path="/notice" element={<Notice />} />
            <Route path="/user" element={<User />} />
            <Route path="/appUpdate" element={<AppUpdate />} />
            <Route path="/tournamentAdmin" element={<TournamentAdmin />} />
            <Route path="/referralSales" element={<ReferralSales />} />
            <Route path="/gameSetting" element={<GameSetting />} />
            <Route path="/advertisement" element={<Advertisement />} />
            <Route path="/faq" element={<Faq />} />
            <Route path="/youtube" element={<Youtube />} />
            <Route path="/youtube-channel" element={<YoutubeChannel />} />
            <Route path="/coupon" element={<Coupon />} />
            <Route path="/game-coupon" element={<GameCoupon />} />
            <Route path="/game-coupon-list" element={<GameCouponList />} />
            <Route path="/attendance-table" element={<AttendanceTable />} />
            <Route path="/attendance-history" element={<AttendanceHistory />} />
            <Route path="/attendance-reward" element={<AttendanceReward />} />
            <Route
              path="/game-inspection-schedule"
              element={<GameInspectionSchedule />}
            />
            <Route path="/user-game-point" element={<UserGamePoint />} />
            <Route path="/club-create" element={<ClubCreate />} />
            <Route path="/manual-gp-payment" element={<ManualGpPayment />} />
            <Route
              path="/manual-gp-payment-log"
              element={<ManualGpPaymentLog />}
            />
            <Route path="/game-ban" element={<GameBan />} />
            <Route path="/image-popup" element={<ImagePopup />} />
            <Route path="/gallery" element={<Gallery />} />
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
